import { useEffect, useState } from "react";
import * as ttapi from "@tomtom-international/web-sdk-services";

function MapDistanceAndTimeUI({
  shiftDown,
  map,
  setMap,
  routePoints,
  setRoutePoints,
  //   options,
  tomtomKey,
}) {
  const [routeTime, setRouteTime] = useState(null);
  const [routeDistance, setRouteDistance] = useState(null);

  //   useEffect(() => {
  //     clearPoints();
  //   }, [options]);

  function getSelectedRoutePointLabels() {
    let point1 = routePoints?.r1;
    let point2 = routePoints?.r2;

    let point1Label = point1?.authorisedBy || point1?.refNumber || "--";
    let point2Label = point2?.authorisedBy || point2?.refNumber || "--";

    return [point1Label, point2Label];
  }

  function drawRoute(geoJson) {
    if (map.getLayer("route")) {
      map.removeLayer("route");
      map.removeSource("route");
    }

    map.addLayer({
      id: "route",
      type: "line",
      source: {
        type: "geojson",
        data: geoJson,
      },
      paint: {
        "line-color": "#2faaff",
        "line-width": 6,
      },
    });

    setMap(map);
  }

  function calculateDistance() {
    let { r1, r2 } = routePoints;

    if (!r1 || !r2) {
      return;
    }

    let formattedPoints = [
      {
        latitude: r1?.position?.lat,
        longitude: r1?.position?.lng,
      },
      {
        latitude: r2?.position?.lat,
        longitude: r2?.position?.lng,
      },
    ];

    ttapi.services
      .calculateRoute({
        key: tomtomKey,
        locations: formattedPoints, //4.8,52.3:4.87,52.37`,
      })
      .then(async (routeData) => {
        let geojson = await routeData.toGeoJson();
        drawRoute(geojson, map);
        setRouteTime(routeData.routes[0]?.summary?.travelTimeInSeconds || null);
        setRouteDistance(routeData.routes[0]?.summary?.lengthInMeters || null);
      });
  }

  function clearPoints() {
    setRoutePoints({ r1: null, r2: null });
    setRouteTime(null);
    setRouteDistance(null);
    if (map.getLayer("route")) {
      map.removeLayer("route");
      map.removeSource("route");
    }
  }

  let [route1Label, route2Label] = getSelectedRoutePointLabels();
  let shiftDownStyle = shiftDown ? "lightgrey" : "none";

  return (
    <div
      className="distance-and-time-display"
      style={{ background: `${shiftDownStyle}` }}
    >
      <div className="controls-and-selected-points">
        <div className="controls">
          <button className="calculateBtn" onClick={() => calculateDistance()}>
            Time
          </button>

          <button className="clearBtn" onClick={clearPoints}>
            Clear
          </button>
        </div>

        <div className="selected-points">
          <p>A: {route1Label}</p>
          <p>B: {route2Label}</p>
        </div>
      </div>

      <div className="distance-and-time-results">
        {routeTime && (
          <>
            <div className="result-line">
              <span className="label">time</span>{" "}
              <span className="result-value">
                {Math.round(Number(routeTime / 60))} mins
              </span>
            </div>
            <div className="result-line">
              <span className="label">distance</span>{" "}
              <span className="result-value">
                {Number(routeDistance / 1609.344).toFixed(1)} miles
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MapDistanceAndTimeUI;
